import { getData } from 'clients/Clients';
import SupplierClient from 'clients/SupplierClient';
import { mapShortNamesLowercase } from 'constants/data/sellers';
import { capitalizeFirstOfEachWords } from './StringUtils';
import { sellerForStore } from './StoreUtils';

const convertShortNames = (name) => {
  if (!name) {
    return '';
  }
  let newName = name?.toLowerCase();
  Object.keys(mapShortNamesLowercase).forEach((keyname) => {
    if (newName.indexOf(keyname) >= 0) {
      newName = newName.replace(keyname, mapShortNamesLowercase[keyname]);
    }
  });

  return capitalizeFirstOfEachWords(newName);
};

const convertSeller = ({
  code,
  name,
  slug,
  sellerClass = '',
  sellerType,
  status,
  slugStore,
  sellerStore,
  avatar = null,
  isVip = null,
  sellerID,
  shortName,
  licenseSellerOnWeb,
  subStores,
}) => {
  const { landingPages, name: storeName, slug: storeSlug = '', logo: storeLogo, status: statusStore } = sellerStore || {};
  return {
    sellerID,
    code,
    name: storeName && statusStore === 'ACTIVE' ? storeName : name,
    shortName: shortName ?? '',
    fullName: statusStore === 'ACTIVE' ? storeName : name,
    slug: statusStore === 'ACTIVE' && storeSlug ? storeSlug : slug, // co the ko co slugStore
    sellerType,
    isInternal: sellerClass === 'INTERNAL',
    status,
    statusStore,
    slugStore: statusStore === 'ACTIVE' ? slugStore : slug,
    landingPage: (landingPages?.length > 0 && landingPages[0]) || '',
    isVip,
    avatar: statusStore === 'ACTIVE' && storeLogo ? storeLogo : avatar,
    storeSlug,
    isStore: status === 'ACTIVE' && statusStore === 'ACTIVE' && storeSlug,
    licenseSellerOnWeb,
    // gian của nhà bán (BV-2164): subStores để thẻ SP / trang SP đổi theo gian chứa SKU (sellerForStore);
    // productFilter của gian mặc định cho "SP cùng nhà bán"
    ...(subStores?.length > 0 ? { subStores } : {}),
    ...(sellerStore?.productFilter ? { productFilter: sellerStore.productFilter } : {}),
  };
};

const fillSellerInfoToProduct = async (products = []) => {
  let sellerCodes = [];
  products?.forEach((item) => {
    if (item.seller && item.seller.code) sellerCodes.push(item.seller.code);
  });
  if (sellerCodes.length) {
    sellerCodes = [...new Set(sellerCodes)];
    const sellers = await SupplierClient.getSellersV2(sellerCodes).then(getData);
    const sellersMap = new Map(sellers.map((seller) => [seller.code, seller]));
    products?.forEach((item) => {
      item.sellerInfo = sellerForStore(sellersMap.get(item.seller.code), item.storeCode);
    });
  }
  return products;
};

export async function fillSellerInfoToProductOnServer({ ctx, products = [] }) {
  let sellerCodes = [];
  products?.forEach((item) => {
    if (item.seller && item.seller.code) sellerCodes.push(item.seller.code);
  });
  if (sellerCodes.length) {
    sellerCodes = [...new Set(sellerCodes)];
    const sellers = await SupplierClient.getSellersV2(sellerCodes).then(getData);
    const sellersMap = new Map(sellers.map((seller) => [seller.code, seller]));
    products?.forEach((item) => {
      const seller = sellersMap.get(item.seller.code);
      Object.keys(seller).forEach((key) => {
        if (seller[key] === null || seller[key] === undefined) delete seller[key];
      });
      item.sellerInfo = sellerForStore(sellersMap.get(item.seller.code), item.storeCode);
    });
  }
  return products;
}

export function getReferrerPath(referrer) {
  if (!referrer) return '';

  try {
    const url = new URL(referrer);
    return url.pathname;
  } catch (error) {
    console.error('Invalid referrer URL:', referrer, error);
    return '';
  }
}

export default {
  convertSeller,
  convertShortNames,
  fillSellerInfoToProduct,
};
